import axios from "../utils/axios";

export enum WeekDay {
  MONDAY    = 'monday',
  TUESDAY   = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY  = 'thursday',
  FRIDAY    = 'friday',
  SATURDAY  = 'saturday',
  SUNDAY    = 'sunday',
}

export type ExecutorSpecialization =
  | 'children'
  | 'adults'
  | 'oge'
  | 'ege'
  | 'vpr'
  | 'ct_ce'
  | 'ielts'
  | 'toefl'
  | 'olympiad';

export type SchedulePlaceOfLesson = 'online' | 'offline' | null;

export interface IExecutor {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  photo: string;
  phone: string;
  email: string;
  about: string;
  interests: string|null;
  directions: string|null;
  experienceFrom: number|null;
  region: string;
  placeOfLesson: string[];
  timeOfLesson: number;
  createdAt: number;
  specializations?: ExecutorSpecialization[];
}

export interface IExecutorCabinet {
  executorId: string;
  subject: string | null;
  isCurrent: boolean;
  switchUrl: string | null;
}

export interface ISchedule {
  id: string;
  startTime: number;
  endTime: number;
  day: string;
  place_of_lesson?: SchedulePlaceOfLesson;
}

export const fetchExecutors = async (search: string, page: number): Promise<{ pages: number; data: IExecutor[] }> => {
  const data = await axios.get("/frontend-api/executor", {
    params: {
      page,
      search
    },
  });

  return data.data;
};

export const fetchExecutorProfile = async (): Promise<{data: IExecutor }> => {
  const data = await axios.get(`/frontend-api/executor/profile`);

  return data.data;
};

export const updateExecutorPersonalInfo = async (
    firstName?: string|null,
    middleName?: string|null,
    lastName?: string|null,
    about?: string|null,
    interests?: string|null,
    directions?: string|null,
    experienceFrom?: string|null,
    specializations?: ExecutorSpecialization[]|null,
): Promise<IExecutor> => {
  const {data} = await axios.patch("/frontend-api/executor/personal-info", {
    firstName,
    middleName,
    lastName,
    about,
    interests,
    directions,
    experienceFrom,
    specializations,
  });

  return data;
};

export const updateExecutorLessonInfo = async (
    placeOfLesson?: string[]|null,
    region?: string|null,
    address?: string|null,
): Promise<IExecutor> => {
  const {data} = await axios.patch("/frontend-api/executor/lesson-info", {
    placeOfLesson,
    region,
    address
  });

  return data;
};

export const fetchExecutorCabinets = async (): Promise<IExecutorCabinet[]> => {
  const data = await axios.get(`/frontend-api/executor/cabinets`);

  return data.data.data;
};

export const fetchSchedules = async (): Promise< ISchedule[] > => {
  const data = await axios.get(`/frontend-api/executor/schedule`);

  return data.data.data;
};

export const addSchedule = async (day: string, startTime: Date|null, endTime: Date|null, placeOfLesson: SchedulePlaceOfLesson): Promise< ISchedule[] > => {
  const data = await axios.post(
      `/frontend-api/executor/schedule`, {
        day,
        startTime: startTime ? Math.floor(startTime.getTime() / 1000) : null,
        endTime: endTime ? Math.floor(endTime.getTime() / 1000) : null,
        place_of_lesson: placeOfLesson,
      }
  );

  return data.data.data;
};

export const updateSchedule = async (schedule: ISchedule, placeOfLesson: SchedulePlaceOfLesson): Promise<ISchedule> => {
  const { data } = await axios.patch(`/frontend-api/executor/schedule/${schedule.id}`, {
    scheduleId: schedule.id,
    day: schedule.day,
    startTime: schedule.startTime,
    endTime: schedule.endTime,
    place_of_lesson: placeOfLesson,
  });

  return data.data;
};

export const deleteSchedule = async (id: string): Promise<void> => {
  await axios.delete(`/frontend-api/executor/schedule/${id}`);
};
